/**
 * Member Join API
 *
 * @author minkyoung.park@emcast.com
*/
import httpService from '@/api/httpService'

const joinApi = {

    // 약관 조회(get Terms and Conditions)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-brand-terms
    terms() {
        return httpService.get(`/guest/${BRAND_CODE}/brand/terms`, '')
    },

    // 인증 사용 방법 조회(get authentication way)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-register-way
    authWay() {
        return httpService.get(`/guest/${BRAND_CODE}/auth/way`, '')
    },

    // 사용자 인증 요청(Request Authentication )
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-register-auth
    auth(params) {
        return httpService.post(`/guest/${BRAND_CODE}/auth`, params)
    },

    // 회원 유형 조회(get role list)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-role
    role() {
        return httpService.get(`/guest/${BRAND_CODE}/role/combo`, '')
    },

    
    // 직무 목록 조회(get duty list)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-duty
    duty(params) {
        return httpService.get(`/guest/${BRAND_CODE}/duty/combo`, params);
    },


    // 직책 목록 조회(get responsibility list)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-responsibility
    responsibility(params) {
        return httpService.get(`/guest/${BRAND_CODE}/responsibility/combo`, params);
    },
    
    // 매장 목록 조회(get store list)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-store
    store(params) {
        return httpService.get(`/guest/${BRAND_CODE}/store/combo`, params);
    },


    // 회원가입(regst member)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-register
    register(params) {
      return httpService.post(`/guest/${BRAND_CODE}/member/register`, params);
    },

    // 외부 URL HTML 호출(get External URL HTML)
    policyContents(url, contentsType, params) {
        return httpService.getExternal(url, contentsType, params)
    },

    // 아이디 중복 확인(check exist ID)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-exists-id
    existsId(params) {
        return httpService.get(`/guest/${BRAND_CODE}/member/exists/id`, params)
    },

    // 소셜 중복 확인(check exist social ID)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-exists-social
    existsSocial(params) {
        return httpService.get(`/guest/${BRAND_CODE}/member/exists/social`, params)
    },
    
    // 직책별 사용자 가입 인증 사용 여부 조회(View whether user subscription certificates are enabled by responsibility)
    // https://clpapi.tinkeredu.co.kr/https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-register-way-fetch-responsibility
    authWayResponsibility(params) {
        return httpService.get(`/guest/${BRAND_CODE}/auth/responsibility/${params.responsibility}/way`)
    },

    // User sign-up authentication request by responsibility
    // https://clpapi.tinkeredu.co.kr/https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-register-auth-brand-request-responsibility
    authResponsibility(params) {
        return httpService.post(`/guest/${BRAND_CODE}/auth/responsibility/${params.responsibility}`, params)
    },

    // 매장 검색(get store search list)
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-store-fetch-page
    searchStore(params) {
        return httpService.get(`/guest/${BRAND_CODE}/store`, params)
    },
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-brand-manager
    managerDetail() {
        return httpService.get(`/guest/${BRAND_CODE}/brand/manager`, '')
    },
    // https://clpapi.tinkeredu.co.kr/static/docs/guest.html#resources-guest-brand-term-date
    termsDate(params) {
        return httpService.get(`/guest/${BRAND_CODE}/brand/termDate`, params);
    },
    // https://dev.clp.kr/spc/api/static/docs/account.html#resources-account-sign-in-password-and-social-firebase_http_request
    authLogin(params) {
        return httpService.post(`/auth/login`, params);
    },
    //https://dev.clp.kr/api/static/docs/guest.html#resources-social-custom-token
    customToken(params) {
        return httpService.get(`/guest/social/customToken`,params);
    },
    /**
     * Guest 사용자 정보 조회(Query guest user information)
     *
     * @param {object} params params.memberId 회원 식별자
     * @returns {AxiosPromise<any>}
     */
    guestUserInfo(params) {
        return httpService.get(`/guest/${BRAND_CODE}/member/${params.memberId}/options`)
    },

}

// export const 
export default joinApi